<section class="site-pricing-box-main-wrap" appIntersectionObserver>
    <div class="container">
        <div class="site-pricing-box">
            <div class="site-pricing-box-row">
                <div class="site-pricing-box-column hidden delay-1">
                    <div class="site-pricing-box-inner-column">
                        <h2>$20.00</h2>
                        <h4 class="site-heading-h4">White label</h4>
                        <p>Custom Designed Report with Your Logo and Details</p>
                    </div>
                </div>
                <div class="site-pricing-box-column hidden delay-2">
                    <div class="site-pricing-box-inner-column">
                        <h2>$20.00</h2>
                        <h4 class="site-heading-h4">Plain Report</h4>
                        <p>No Logo or Company Details</p>
                    </div>
                </div>
                <div class="site-pricing-box-column hidden delay-3">
                    <div class="site-pricing-box-inner-column">
                        <h2>$149</h2>
                        <h4 class="site-heading-h4">Deep Social Media
                            VIP Express Service</h4>
                        <p>24hr Working Day</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>